export const ADD_CONTACT = 'ADD_CONTACT'
export const ADD_CONTACT_SUCCESS = 'ADD_CONTACT_SUCCESS'
export const ADD_CONTACT_FAILURE = 'ADD_CONTACT_FAILURE'
